import React,{useEffect, useState} from "react";
import CustomHeading from '../../../constants/CustomHeading';
import CustomDropdown from '../../../constants/CustomDropdown';
import CustomInput from '../../../constants/CustomInput';
import { Formik,Form } from "formik";
import * as Yup from 'yup';
import CustomTextArea from "../../../constants/CustomTextArea";
import CustomButton from "../../../constants/CustomButton";
import {getdepartmentData,getSendMailData,getDepartmentUserListData,getProfileData,setSendMailData} from "../../../redux/actions/dataAction";
import {connect} from 'react-redux';
import CustomLine from "../../../constants/CustomLine";
import CustomSimpleTable from "../../../constants/CustomSimpleTable";

const sendMailSchema = Yup.object().shape({
  to: Yup.string()
    .email('Not valid email'),
  subject: Yup.string()
    .required('Required'),
  email_body: Yup.string()
    .required('Required'),

 
});
const SendMail = (props) => {
    const [role,setRole]=useState();
    const [department,setDepartment]=useState();
    const [emails,setEmails]=useState();
    useEffect(()=>{
        props.getdepartmentData();
        props.getSendMailData();
        props.getProfileData();
       
      },[])
      
    useEffect(()=>{
        if(department){
            props.getDepartmentUserListData(department);
        }
    },[department])

    useEffect(()=>{
        let users=props?.department_user?.data;
        let email="";
        if(role){
            users= props?.department_user?.data?.filter(u=>u.designation[0]===role);
        }
        if(users){
            email=email+users?.map(user=>{
                return `${user.email}`;
            })
        }
        setEmails(emails);
    },[props?.department_user?.data])
   const columns=[
       {title:'Subject',field:'subject'},
       {title:'Email Body',field:'email_body'},
   ]
  return (
   <div className={'customContainer'}>
       <CustomHeading title="Send Mail"/>
  

            <Formik 
                initialValues={{
                   to:'',
                   cc:'',
                   subject:'',
                   email_body:'',
                   signature:'',
                   department:'',
                   role:'',
                   attachments:'',
                   }}
                   validationSchema={sendMailSchema}
                   onSubmit={values => {
                    let data={
                        to:values.to!==''?values.to:props?.profile?.data?.email,
                        cc:values.cc!==''?values.cc:emails,
                        subject:values.subject,
                        email_body:values.email_body,
                        signature:values.signature!==''?values.signature:`${props?.profile?.data?.first_name} ${props?.profile?.data?.last_name}`,
                        role:role,
                        attachments:values.attachments,
                        department:department,
                    }
                    props.setSendMailData(data);
                  }}
            >
            {({ errors, touched,handleChange,handleSubmit }) => (
            <Form onSubmit={handleSubmit} style={{marginTop:0}}>
                      <div className="row">
            <div className="col-md-6">
            <CustomDropdown 
                label="Role"
                data={[{value:"admin",key:"Admin"},{value:"user",key:'User'}]}
                onChange={(e)=>setRole(e.target.value)}
                />
            </div>
            <div className="col-md-6">
            <CustomDropdown
            label="Department :"
            data={props?.department?.data?.map(d=>{
                return(
                    {value:d.short_name,key:d.name}
                )
            })}
            notDefaultOption
            defaultOption={"Select Department"}
            onChange={(e)=>setDepartment(e.target.value)}
            />
            </div>

        </div>
            <CustomInput
                type={'text'}
                label={'To :'}
                onChange={handleChange('to')}
                errorText={
                    errors.to && touched.to ?errors.to :null
                }
                value={props?.profile?.data?.email}
            />
            <CustomInput
                type={'text'}
                label={'Cc :'}
                onChange={handleChange('cc')}
                value={emails}
                
            />
            <CustomInput
                type={'text'}
                label={'Subject :'}
                onChange={handleChange('subject')}
                errorText={
                    errors.subject && touched.subject ?errors.subject :null
                }
            />
            <CustomTextArea
                type={'text'}
                label={'Email body'}
                onChange={handleChange('email_body')}
                errorText={
                    errors.email_body && touched.email_body ?errors.email_body :null
                }

            />
            <div className={'row'}>
            <div className={'col-md-4'}>
            <CustomTextArea
                type={'text'}
                label={'Signature'}
                onChange={handleChange('signature')}
                errorText={
                    errors.signature && touched.signature ?errors.signature :null
                }
                value={`${props?.profile?.data?.first_name} ${props?.profile?.data?.last_name}`}
            />
            </div>
            <div className={'col-md-4 mt-4'}>
            <CustomButton type="submit" label="Send" isIcon onSubmit={handleSubmit}/>
            </div>
            </div>
            
            </Form>
              )}
            </Formik>
            <CustomLine/>
            <div className={'mb-5'}>
            <CustomSimpleTable data={props?.send_mail?.data} columns={columns} title="All Mails"/>
            </div>
   </div>
  );
};
const mapActionWithProps = {
    getdepartmentData,
    getSendMailData,
    getDepartmentUserListData,
    getProfileData,
    setSendMailData,
  }
  
  const mapStateWithProps = (state)=>(
    {
      department:state.data.department,
      send_mail:state.data.send_mail,
      department_user:state.data.department_user,
      profile:state.data.profile,
    }
  )
  export default connect(mapStateWithProps,mapActionWithProps)(SendMail);
